<script>
import baseMixin from '@/mixins/baseMixin'

export default {
  name: 'TruncatedChipList',
  mixins: [baseMixin],
  inheritAttrs: false,
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    /**
     * Enables the truncated chips to be fully displayed when clicking on the
     * summary chip (the '+ X more' chip)
     */
    expandable: {
      type: Boolean,
    },
    /**
     * Number of items displayed before being truncated
     */
    limit: {
      type: Number,
      default: 0,
      validator(limitVal) {
        // Should be a positive number
        return !(limitVal < 0)
      },
    },
    /**
     * Allows chips to be closed/removed
     */
    closeable: {
      type: Boolean,
    },
  },
  data: () => {
    return {
      expanded: false,
    }
  },
  computed: {
    shouldItemsBeTruncated() {
      if (this.limit === 0) return false
      return this.items.length > this.limit
    },
    truncatedList() {
      if (this.expanded || !this.shouldItemsBeTruncated) return this.items

      return this.items.slice(0, this.limit)
    },
    compSummaryChipText() {
      return !this.expanded
        ? this.$t('general.truncate.tooltip', [this.items.length - this.limit])
        : 'Hide'
    },
    compSummaryChipTooltip() {
      return !this.expanded ? 'Show all items' : ''
    },
    compChipColor() {
      if (this.hasColorAttr) return this.$attrs.color
      return this.isDarkMode ? null : 'grey'
    },
    compSummaryChipColor() {
      if (this.hasColorAttr) return this.$attrs.color
      return this.isDarkMode ? '#00000000' : 'white'
    },
    hasColorAttr() {
      return !!this.$attrs?.color
    },
  },
  methods: {
    closeChip(item) {
      if (!this.closeable) return false
      this.$emit('closeChip', item)
    },
    toggleExpand() {
      if (!this.expandable) return false
      this.expanded = !this.expanded
    },
  },
}
</script>

<template>
  <div>
    <v-scroll-x-transition group hide-on-leave>
      <v-chip
        v-for="(item, i) in truncatedList"
        :key="i"
        :color="compChipColor"
        dark
        v-bind="$attrs"
        class="ma-1"
        :close="closeable"
        v-on="$listeners"
        @click:close="closeChip(item)"
      >
        {{ item.title }}
      </v-chip>
    </v-scroll-x-transition>

    <v-tooltip :disabled="!expandable || expanded" top>
      <template v-slot:activator="{ on: onTooltip }">
        <v-chip
          v-show="shouldItemsBeTruncated"
          dark
          :color="compSummaryChipColor"
          v-bind="$attrs"
          :class="['ma-1', hasColorAttr ? '' : 'blue--text']"
          @click="toggleExpand"
          v-on="onTooltip"
        >
          <v-avatar v-if="expanded" left>
            <v-icon small>mdi-eye-off</v-icon>
          </v-avatar>

          {{ compSummaryChipText }}
        </v-chip>
      </template>
      {{ compSummaryChipTooltip }}
    </v-tooltip>
  </div>
</template>
